/**
 * Provider Grid Component
 * Grid de seleção de providers de integração para databases
 */

import React from 'react';
import type { DatabaseProvider } from '@/providers/database';
import { Icon } from '@/shared/icons';

export interface ProviderGridProps {
  /** Providers disponíveis para seleção */
  providers: DatabaseProvider[];
  /** ID do provider selecionado */
  selectedProviderId: string | null;
  /** Callback quando um provider é selecionado */
  onSelectProvider: (providerId: string) => void;
  /** Mostrar opção "Nenhum" (sem integração) */
  showNoneOption?: boolean;
}

export const ProviderGrid: React.FC<ProviderGridProps> = ({
  providers,
  selectedProviderId,
  onSelectProvider,
  showNoneOption = true,
}) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
      {/* Opção "Nenhum" */}
      {showNoneOption && (
        <button
          onClick={() => onSelectProvider('none')}
          className="p-4 rounded-lg border-2 text-left transition-all"
          style={{
            borderColor: selectedProviderId === 'none' ? '#8b5cf6' : '#e5e7eb',
            backgroundColor: selectedProviderId === 'none' ? 'rgba(139, 92, 246, 0.05)' : '#ffffff',
          }}
        >
          <div className="text-center py-4">
            <h3 className="text-sm font-semibold" style={{ color: '#1e293b' }}>
              Nenhum
            </h3>
            <p className="text-xs mt-1" style={{ color: '#64748b' }}>
              Continuar sem integração
            </p>
          </div>
        </button>
      )}

      {/* Providers disponíveis */}
      {providers.map((provider) => {
        const isSelected = selectedProviderId === provider.id;

        return (
          <button
            key={provider.id}
            onClick={() => onSelectProvider(provider.id)}
            className="p-4 rounded-lg border-2 text-left transition-all"
            style={{
              borderColor: isSelected ? '#8b5cf6' : '#e5e7eb',
              backgroundColor: isSelected ? 'rgba(139, 92, 246, 0.05)' : '#ffffff',
            }}
          >
            <div className="flex items-start gap-3">
              <div
                className="p-2 rounded-lg flex-shrink-0"
                style={{
                  backgroundColor: `${provider.color}20`,
                  color: provider.color,
                }}
              >
                {provider.icon && <Icon name={provider.icon} className="w-5 h-5" />}
              </div>
              <div className="flex-1">
                <h3 className="text-sm font-semibold" style={{ color: '#1e293b' }}>
                  {provider.name}
                </h3>
                <p className="text-xs mt-1" style={{ color: '#64748b' }}>
                  {provider.description}
                </p>
              </div>
            </div>
          </button>
        );
      })}
    </div>
  );
};
